import { z } from "zod";
import { PaymentClient } from "../types/transaction";

export const EnvConfigSchema = z.object({
  websocketUrl: z.string(),
  apiBaseUrl: z.string(),
  unsplashAccessKey: z.string(),
  unsplashItemsPerPage: z.number(),
  giphyAccessKey: z.string(),
  appPublicUrl: z.string(),
  frontendAppUrl: z.string(),
  cloudinaryCloudName: z.string(),
  cloudinaryUploadPreset: z.string(),
  budpayPublicKey: z.string(),
  paystackPublicKey: z.string(),
  flutterwavePublicKey: z.string(),
  cateringFeatureList: z.array(z.string()),
  paymentClient: z.string(),
  uploadThingToken: z.string().optional(),
  appEnv: z.string().optional(),
  whatsappWabaId: z.string().optional(),
  whatsappPhoneNumberId: z.string().optional(),
  whatsappApiVersion: z.string().optional(),
  whatsappAccessToken: z.string().optional(),
  template3Accounts: z.array(z.string()),
});

type EnvConfigType = z.infer<typeof EnvConfigSchema> & {
  paymentClient: PaymentClient;
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
const EnvConfig = {
  websocketUrl: import.meta.env.VITE_WEBSOCKET_URL,
  apiBaseUrl: import.meta.env.VITE_BASE_URL,
  unsplashAccessKey: import.meta.env.VITE_UNSPLASH_ACCESS_KEY,
  unsplashItemsPerPage: Number(import.meta.env.VITE_UNSPLASH_PER_PAGE),
  giphyAccessKey: import.meta.env.VITE_GIPHY_ACCESS_KEY,
  appPublicUrl: import.meta.env.VITE_PUBLIC_URL,
  cateringFeatureList:
    import.meta.env.VITE_CATERING_FEATURE_LIST?.split?.(",") || [],
  frontendAppUrl: import.meta.env.VITE_FRONTEND_URL,
  cloudinaryCloudName: import.meta.env.VITE_CLOUDINARY_CLOUD_NAME,
  cloudinaryUploadPreset: import.meta.env.VITE_CLOUDINARY_UPLOAD_PRESET,
  budpayPublicKey: import.meta.env.VITE_BUDPAY_PUBLIC_KEY,
  paystackPublicKey: import.meta.env.VITE_PAYSTACK_TEST_PUBLIC_KEY,
  flutterwavePublicKey: import.meta.env.VITE_FLUTTERWAVE_TEST_PUBLIC_KEY,
  paymentClient: import.meta.env.VITE_PAYMENT_CLIENT,
  uploadThingToken: import.meta.env.VITE_UPLOADTHING_TOKEN,
  appEnv: import.meta.env.VITE_APP_ENV,
  whatsappWabaId: import.meta.env.VITE_WABA_ID,
  whatsappPhoneNumberId: import.meta.env.VITE_PHONE_NUMBER_ID,
  whatsappApiVersion: import.meta.env.VITE_WHATSAPP_API_VERSION,
  whatsappAccessToken: import.meta.env.VITE_WHATSAPP_ACCESS_TOKEN,
  template3Accounts:
    import.meta.env.VITE_TEMPLATE_3_ACCOUNTS?.split?.(",") || [],
} as EnvConfigType;

EnvConfigSchema.parse(EnvConfig);

export default EnvConfig;
